import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { snap, story, visualize } from 'storybook-snapper';
import { Counter, CounterSize } from '..';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { classes } from './Counter.visual.st.css';
import { counterDriverFactory } from './Counter.driver';
import { VisualAsync } from '../../test/visual/VisualAsync';

class CounterVisual extends React.Component<any> {
  render() {
    return (
      <VisualTestContainer>
        <div style={this.props?.style}>
          <Counter inputAriaLabel="amount" onChange={() => {}} {...this.props} />
        </div>
      </VisualTestContainer>
    );
  }
}

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {},
      },
      {
        it: 'disabled',
        props: { disabled: true },
      },
      {
        it: 'error',
        props: { error: true },
      },
      {
        it: 'error message',
        props: { error: true, errorMessage: 'Error' },
      },
      {
        it: 'newErrorMessage',
        props: { error: true, errorMessage: 'Error', newErrorMessage: true },
      },
      {
        it: 'label',
        props: { label: 'Quantity' },
      },
      {
        it: 'label with asterisk',
        props: { label: 'Quantity', required: true, showAsterisk: true },
      },
      {
        it: 'disabled minus',
        props: { min: 10, value: 10 },
      },
      {
        it: 'disabled plus',
        props: { max: 10, value: 10 },
      },
      {
        it: 'xSmal',
        props: { size: CounterSize.xSmall },
      },
      {
        it: 'xSmal disabled',
        props: { size: CounterSize.xSmall, disabled: true },
      },
      {
        it: 'xSmal error',
        props: { size: CounterSize.xSmall, error: true },
      },
      {
        it: 'xSmal error message',
        props: { size: CounterSize.xSmall, error: true, errorMessage: 'Error' },
      },
      {
        it: 'xSmall newErrorMessage',
        props: {
          size: CounterSize.xSmall,
          error: true,
          newErrorMessage: true,
          errorMessage: 'Error',
        },
      },
    ],
  },
];

const wstThemeTests = [{
  describe: 'with wst theme',
  its: [
    {
      it: 'default',
      props: {
        label: "Quantity",
        value: 3,
        style: {
          '--wst-paragraph-2-font-family': 'Courier New, serif',
          '--wst-paragraph-2-font-weight': 'bold',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-variant': 'small-caps',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-color-rgb': '0,155,255',
          '--wst-primary-background-color-rgb': '255,200,0',
          '--wst-shade-3-color-rgb': '255,0,0',
        },
      },
    },
    {
      it: 'disabled state',
      props: {
        disabled: true,
        label: "Quantity",
        value: 3,
        style: {
          '--wst-system-disabled-color-rgb': '128,0,128',
        },
      },
    },
  ],
}];

const styleOverrides = [
  {
    property: 'MainFont',
    className: classes.mainFont,
  },
  {
    property: 'MainBackgroundColor',
    className: classes.mainBgColor,
  },
  {
    property: 'MainBackgroundColorOpaque',
    className: classes.mainBgColorOpaque,
  },
  {
    property: 'MainBorderRadius',
    className: classes.mainBorderRadius,
  },
  {
    property: 'MainBorderWidth',
    className: classes.mainBorderWidth,
  },
  {
    property: 'TextColor',
    className: classes.textColor,
  },
  {
    property: 'BorderColor',
    className: classes.borderColor,
  },
  {
    property: 'ErrorColor',
    className: classes.errorColor,
  },
  {
    property: 'ErrorMessageMinHeight',
    className: classes.errorMessageMinHeight,
  },
  {
    property: 'DisabledColor',
    className: classes.disabledColor,
  },
  {
    property: 'DisabledBorderColor',
    className: classes.disabledBorderColor,
  },
  {
    property: 'LabelFont',
    className: classes.labelFont,
  },
  {
    property: 'LabelColor',
    className: classes.labelColor,
  },
  {
    property: 'TouchAreas',
    className: classes.touchAreas,
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`Counter/${describe}`, module).add(it, () => (
      <CounterVisual {...props} />
    ));
  });

  styleOverrides.forEach(({ property, className }) => {
    storiesOf(`Counter/Style Overrides`, module).add(property, () => (
      <table>
        {its.map(({ it, props }) => (
          <tr key={it}>
            <td>{it}</td>
            <td>
              <CounterVisual className={className} {...props} />
            </td>
          </tr>
        ))}
      </table>
    ));
  });
});

visualize('Counter', () => {
  tests.forEach(({ describe, its }) => {
    story(`${describe} click focus`, () => {
      its.forEach(({ it, props }) => {
        snap(`${it}`, (done) => (
          <VisualAsync
            driverFactory={counterDriverFactory}
            onDone={done}
            action={(driver) => driver.click()}
          >
            <Counter inputAriaLabel="amount" onChange={() => {}} {...props} />
          </VisualAsync>
        ));
      });
    });
  });
});

wstThemeTests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`Counter/${describe}`, module).add(it, () => (
      <CounterVisual {...props} />
    ));
  });
});
